import { connect } from 'react-redux';
import { connect as connectRefetch } from 'react-refetch';
import { compose, withProps } from 'recompose';

import { getProjectsCached } from '../../redux/actions/project';
import { StoreState } from '../../redux/reducers/store.types';
import { Dispatch } from '../../redux/redux.types';
import { getSelectedOrganizationId } from '../../selectors/organizations/organizations';
import { RouterContext } from '../../types/router';

import { getInvitationsCached, getTeamMembersCached } from './team.actions';
import { TeamLazyLoadContainer } from './team.lazy';

export interface TeamDataLoaderOwnProps {
  router: RouterContext;
}

export interface TeamDataLoaderStateProps {
  organizationId: string;
}

export interface TeamDataLoaderDispatchProps {
  getInvitationsCached(): Promise<void>;
  getProjectsCached(organizationId: string): void;
  getTeamMembersCached(): Promise<void>;
}

export interface TeamDataLoaderRefetchProps {
  getInvitationsFetch: {
    value(): Promise<void>;
    comparison: string;
  };
  getProjectsFetch: {
    value(): Promise<void>;
    comparison: string;
  };
  getTeamMembersFetch: {
    value(): Promise<void>;
    comparison: string;
  };
}

export const TeamDataLoader = compose<any, any>(
  withProps(({ router }: TeamDataLoaderOwnProps) => ({
    router,
  })),
  connect(
    (state: StoreState): TeamDataLoaderStateProps => ({
      organizationId: getSelectedOrganizationId(state),
    }),
    (
      dispatch: Dispatch,
      { router }: TeamDataLoaderOwnProps,
    ): TeamDataLoaderDispatchProps => ({
      getInvitationsCached: () => {
        return dispatch(getInvitationsCached(router));
      },
      getProjectsCached: (organizationId: string) => {
        dispatch(getProjectsCached(organizationId));
      },
      getTeamMembersCached: () => {
        return dispatch(getTeamMembersCached(router));
      },
    }),
  ),
  connectRefetch(
    ({
      getInvitationsCached,
      getProjectsCached,
      getTeamMembersCached,
      organizationId,
    }): TeamDataLoaderRefetchProps => ({
      getInvitationsFetch: {
        value: () => getInvitationsCached(),
        comparison: organizationId,
      },
      getProjectsFetch: {
        value: () => getProjectsCached(organizationId),
        comparison: organizationId,
      },
      getTeamMembersFetch: {
        value: () => getTeamMembersCached(),
        comparison: organizationId,
      },
    }),
  ),
)(TeamLazyLoadContainer);
